import React from 'react';
import '../style/home.css';
import PcardForm from '../forms/PcardForm';
import { FaIdCard } from "react-icons/fa";
import { useTranslation } from "react-i18next";

const AddPcard = () => {
   const { t } = useTranslation();
  return (
    <div className='add_card'>
      <h3 className='text-center m-3'> <FaIdCard/> {t("HEADING.ADDCARDTITLE")} </h3>
       <PcardForm translate={t} />
    </div>
  )
}

export default AddPcard
